import {useEffect, useState} from 'react'
import {useAuth} from '../../../../modules/auth'
import db from '../../../../../services/firebase'
import {collection, doc, onSnapshot, query, where} from 'firebase/firestore'
import FrameworksCard from './HeaderCards/FrameworkCard'
import { Link } from 'react-router-dom'

const DashboardPageHeader = () => {
  const [totalPersonnel, setTotalPersonnel] = useState(0)
  const {currentUser} = useAuth()
  const [totalOffboarded, setTotalOffboarded] = useState(0)
  const [totalOnboarded, setTotalOnboarded] = useState(0)
  const [criticalRisks, setCriticalRisks] = useState(0)
  const [highRisks, setHighRisks] = useState(0)
  const [mediumRisks, setMediumRisks] = useState(0)
  const [lowRisks, setLowRisks] = useState(0)

  useEffect(() => {
    if (!currentUser?.tenantId) {
      return
    }

    const tenantId = currentUser.tenantId
    const tenantRef = doc(db, 'tenants', tenantId)
    const policyRef = collection(tenantRef, 'employees')

    const unsubscribeTotal = onSnapshot(policyRef, (snapshot) => {
      const personnelCount = snapshot.size
      setTotalPersonnel(personnelCount)
    })

    const offboardedQuery = query(policyRef, where('end_date', '!=', null))
    const unsubscribeOffboarded = onSnapshot(offboardedQuery, (snapshot) => {
      const offboardedCount = snapshot.size
      setTotalOffboarded(offboardedCount)
    })

    const onboardedQuery = query(policyRef, where('onboarding', '==', 'Completed'))
    const unsubscribeOnboarded = onSnapshot(onboardedQuery, (snapshot) => {
      const onboardedCount = snapshot.size
      setTotalOnboarded(onboardedCount)
    })

    return () => {
      unsubscribeTotal()
      unsubscribeOffboarded()
      unsubscribeOnboarded()
    }
  }, [currentUser])

  useEffect(() => {
    if (!currentUser?.tenantId) {
      return
    }

    const tenantId = currentUser.tenantId
    const tenantRef = doc(db, 'tenants', tenantId)
    const risksRef = collection(tenantRef, 'risks')

    const unsubscribe = onSnapshot(risksRef, (snapshot) => {
      const risksData = snapshot.docs.map((doc) => ({
        id: doc.id,
        residualImpact: doc.data().residual_impact,
        residualLikelihood: doc.data().residual_likelihood,
        ...doc.data(),
      }))

      let criticalCount = 0
      let highCount = 0
      let mediumCount = 0
      let lowCount = 0

      risksData.forEach((risk) => {
        const riskLevel = risk.residualImpact * risk.residualLikelihood

        if (riskLevel >= 25) {
          criticalCount++
        } else if (riskLevel >= 15) {
          highCount++
        } else if (riskLevel >= 5) {
          mediumCount++
        } else {
          lowCount++
        }
      })

      setCriticalRisks(criticalCount)
      setHighRisks(highCount)
      setMediumRisks(mediumCount)
      setLowRisks(lowCount)
    })

    return unsubscribe 
  }, [currentUser])
  
  return (
    <>
      <div className='row gx-5 gx-xl-10 ' style={{marginBottom:'24px'}}>

      <FrameworksCard />
        {/*begin::Col*/}
        <div className='col-sm-4' >
          {/*begin::List widget 1*/}
          <div className='card card-flush h-lg-80' style={{ padding: "24px" }}>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bold fs-4 text-dark'>Employees</span>
              </h3>
            <div className=' pt-0'>
              {/*begin::Item*/}
              <div className='d-flex flex-stack mt-5'>
                {/*begin::Section*/}
                <div className='text-gray-700 fw-semibold fs-6 me-2'>
                <div className='d-inline-block me-2 align-items-center'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='18'
                      height='18'
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='#5E6274'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      className='icon icon-tabler icons-tabler-outline icon-tabler-users mb-1'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0' />
                      <path d='M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2' />
                      <path d='M16 3.13a4 4 0 0 1 0 7.75' />
                      <path d='M21 21v-2a4 4 0 0 0 -3 -3.85' />
                    </svg>
                  </div>
                  Total Employees
                </div>

                {/*end::Section*/}
                {/*begin::Statistics*/}
                <div className='d-flex align-items-senter'>
                  {/*begin::Number*/}
                  <span className='text-gray-900 fw-bold'>{totalPersonnel}</span>
                  {/*end::Number*/}
                </div>
                {/*end::Statistics*/}
              </div>
              {/* <div className='my-3'></div> */}

              <div className='d-flex flex-stack mt-4'>
                {/*begin::Section*/}
                <div className='text-gray-700 fw-semibold fs-6 me-2'>
                <div className='d-inline-block me-2 align-items-center'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='18'
                      height='18'
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='#5E6274'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      className='icon icon-tabler icons-tabler-outline icon-tabler-user-check mb-1'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0' />
                      <path d='M6 21v-2a4 4 0 0 1 4 -4h4' />
                      <path d='M15 19l2 2l4 -4' />
                    </svg>
                  </div>
                  Onboarded
                </div>

                <div className='d-flex align-items-senter'>
                  <span className='text-gray-900 fw-bold'>{totalOnboarded}</span>
                </div>
              </div>
              <div className='d-flex flex-stack mt-4'>
                {/*begin::Section*/}
                <div className='text-gray-700 fw-semibold fs-6 me-2'>
                  <div className='d-inline-block me-2 align-items-center'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='18'
                      height='18'
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='#EE3043'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      className='icon icon-tabler icons-tabler-outline icon-tabler-alert-triangle mb-1'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M12 9v4' />
                      <path d='M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z' />
                      <path d='M12 16h.01' />
                    </svg>
                  </div>
                  Offboarded
                </div>
                {/*end::Section*/}
                {/*begin::Statistics*/}
                <div className='d-flex align-items-senter'>
                  {/*begin::Number*/}
                  <span className='text-gray-900 fw-bold'>{totalOffboarded}</span>
                  {/*end::Number*/}
                </div>
                {/*end::Statistics*/}
              </div>

              <div className="d-flex justify-content-between align-items-center mt-4">
                <div
                  className="d-flex align-items-center hover-group"
                  style={{ cursor: "pointer" }}
                >
                  <Link
                    to="/employees"
                    className="text-dark fw-medium text-decoration-underline hover-text hover-text-decoration-underline me-1"
                  >
                    View employees
                  </Link>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-right transition-transform hover-effect"
                    style={{ transition: "transform 0.2s ease-in-out" }}
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M9 6l6 6l-6 6" />
                  </svg>
                  <style>
                    {`
                      .hover-group:hover .hover-effect {
                        transform: translateX(3px);
                      }
                      .hover-group:hover .hover-text {
                        color: #6c757d !important;
                      }
                      .hover-group:hover svg {
                        stroke: #6c757d;
                      }
                    `}
                  </style>
                </div>
              </div>
            </div>
            {/*end::Body*/}
          </div>
          {/*end::LIst widget 1*/}
        </div>
        {/*end::Col*/}

        <div className='col-sm-4' >
          {/*begin::List widget 1*/}
          <div className='card card-flush h-lg-80' style={{ padding: "24px" }}>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bold fs-4 text-dark'>Residual Risk</span>
              </h3>
            <div className=' pt-0'>
              {/*begin::Item*/}
              <div className='d-flex flex-stack mt-5'>
                {/*begin::Section*/}
                <div className='text-gray-700 fw-semibold fs-6 me-2'>
                <div className='d-inline-block me-2 align-items-center'>
                <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='18'
                      height='18'
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='#EE3043'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      className='icon icon-tabler icons-tabler-outline icon-tabler-bolt mb-1'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M13 3l0 7l6 0l-8 11l0 -7l-6 0l8 -11' />
                    </svg>
                  </div>
                  Critical
                </div>

                {/*end::Section*/}
                {/*begin::Statistics*/}
                <div className='d-flex align-items-senter'>
                  {/*begin::Number*/}
                  <span className='text-gray-900 fw-bold'>{criticalRisks}</span>
                  {/*end::Number*/}
                </div>
                {/*end::Statistics*/}
              </div>
              {/* <div className='my-3'></div> */}

              <div className='d-flex flex-stack mt-4'>
                {/*begin::Section*/}
                <div className='text-gray-700 fw-semibold fs-6 me-2'>
                <div className='d-inline-block me-2 align-items-center'>
                <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='18'
                      height='18'
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='#FFA800'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      className='icon icon-tabler icons-tabler-outline icon-tabler-recharging mb-1'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M7.038 4.5a9 9 0 0 0 -2.495 2.47' />
                      <path d='M3.186 10.209a9 9 0 0 0 0 3.508' />
                      <path d='M4.5 16.962a9 9 0 0 0 2.47 2.495' />
                      <path d='M10.209 20.814a9 9 0 0 0 3.5 0' />
                      <path d='M16.962 19.5a9 9 0 0 0 2.495 -2.47' />
                      <path d='M20.814 13.791a9 9 0 0 0 0 -3.508' />
                      <path d='M19.5 7.038a9 9 0 0 0 -2.47 -2.495' />
                      <path d='M13.791 3.186a9 9 0 0 0 -3.508 -.02' />
                      <path d='M12 8l-2 4h4l-2 4' />
                      <path d='M12 21a9 9 0 0 0 0 -18' />
                    </svg>
                  </div>
                  High
                </div>

                <div className='d-flex align-items-senter'>
                  <span className='text-gray-900 fw-bold'>{highRisks}</span>
                </div>
              </div>
              <div className='d-flex flex-stack mt-4'>
                {/*begin::Section*/}
                <div className='text-gray-700 fw-semibold fs-6 me-2'>
                  <div className='d-inline-block me-2 align-items-center'>
                  <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='18'
                      height='18'
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='#5E6274'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      className='icon icon-tabler icons-tabler-outline icon-tabler-circle-dashed mb-1'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M8.56 3.69a9 9 0 0 0 -2.92 1.95' />
                      <path d='M3.69 8.56a9 9 0 0 0 -.69 3.44' />
                      <path d='M3.69 15.44a9 9 0 0 0 1.95 2.92' />
                      <path d='M8.56 20.31a9 9 0 0 0 3.44 .69' />
                      <path d='M15.44 20.31a9 9 0 0 0 2.92 -1.95' />
                      <path d='M20.31 15.44a9 9 0 0 0 .69 -3.44' />
                      <path d='M20.31 8.56a9 9 0 0 0 -1.95 -2.92' />
                      <path d='M15.44 3.69a9 9 0 0 0 -3.44 -.69' />
                    </svg>
                  </div>
                  Medium
                </div>
                {/*end::Section*/}
                {/*begin::Statistics*/}
                <div className='d-flex align-items-senter'>
                  {/*begin::Number*/}
                  <span className='text-gray-900 fw-bold'>{mediumRisks}</span>
                  {/*end::Number*/}
                </div>
                {/*end::Statistics*/}
              </div>

              <div className="d-flex justify-content-between align-items-center mt-4">
                <div
                  className="d-flex align-items-center hover-group"
                  style={{ cursor: "pointer" }}
                >
                  <Link
                    to="/risk-management"
                    className="text-dark fw-medium text-decoration-underline hover-text hover-text-decoration-underline me-1"
                  >
                    View risk
                  </Link>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-right transition-transform hover-effect"
                    style={{ transition: "transform 0.2s ease-in-out" }}
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M9 6l6 6l-6 6" />
                  </svg>
                  <style>
                    {`
                      .hover-group:hover .hover-effect {
                        transform: translateX(3px);
                      }
                      .hover-group:hover .hover-text {
                        color: #6c757d !important;
                      }
                      .hover-group:hover svg {
                        stroke: #6c757d;
                      }
                    `}
                  </style>
                </div>
              </div>
            </div>
            {/*end::Body*/}
          </div>
          {/*end::LIst widget 1*/}
        </div>

      </div>
    </>
  )
}

export default DashboardPageHeader
